// @flow
import { createSelector } from 'reselect';
import { MOUNT_POINT } from './constants';
import type { State, User, Permissions } from './reducer';

export const getAuthState = (state: Object): State => state[MOUNT_POINT];

export const getUser: (state: State) => User = createSelector(getAuthState, (state) => state.user);

export const getUserPermissions: (state: State) => Permissions = createSelector(
    getAuthState, (state) => state.permissions,
);

export const getUserFullName: (state: State) => string = createSelector(getUser, (user) => {
    if (user) {
        if (user.firstName && user.lastName) {
            return `${user.firstName} ${user.lastName}`.trim();
        }
        return user.username;
    }
    return '';
});

const getPermissionFromProps = (state: State, props: Object) => props.permissions;

export const getHasPermissions: (state: State, props: Object) => Permissions = createSelector(
    [getPermissionFromProps, getUserPermissions], (permissions, USER_PERMISSIONS) => {
        let hasPermissions = !!USER_PERMISSIONS;
        const hasPermArr = [];
        let checkPerm = false;
        if (permissions && USER_PERMISSIONS) {
            permissions.forEach((val) => {
                hasPermissions = USER_PERMISSIONS.includes(val);
                hasPermArr.push(hasPermissions);
            });
            checkPerm = hasPermArr.every((val) => (val === true));
        }

        return checkPerm;
    },
);
